'use client';

import { RefObject, useEffect, useState } from 'react';

export function useCarouselMediaHeight(
  viewportRef: RefObject<HTMLElement | null>,
) {
  const [mediaHeight, setMediaHeight] = useState<number>(0);

  useEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;

    const getMediaEl = () =>
      viewport.querySelector<HTMLElement>('[data-carousel-media]');

    const update = () => {
      const el = getMediaEl();
      if (!el) return;
      const h = Math.round(el.getBoundingClientRect().height);
      setMediaHeight(h);
    };

    update();

    const ro = new ResizeObserver(() => update());
    ro.observe(viewport);

    const media = getMediaEl();
    if (media) ro.observe(media);

    window.addEventListener('resize', update);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [viewportRef]);

  return mediaHeight;
}
